import { createSelector } from 'reselect';
import { groupIdsSelector } from './groups';

export const accountIdsSelector = (state) => state.accounts.accountIds;
export const sortedAccountIdsSelector = (state) =>
  state.accounts.sortedAccountIds;
export const accountsByIdSelector = (state) => state.accounts.accountsById;

const accountsSelectorCombiner = (accountIds, accountsById) => {
  if (!accountIds) {
    return [];
  }

  return accountIds.map((id) => ({
    id: parseInt(id, 10),
    ...accountsById[id],
  }));
};

export const accountsSelector = createSelector(
  accountIdsSelector,
  accountsByIdSelector,
  accountsSelectorCombiner
);

export const sortedAccountsSelector = createSelector(
  sortedAccountIdsSelector,
  accountsByIdSelector,
  accountsSelectorCombiner
);

/**
 *   {
 *    [groupId]: [accountId1, accountId2, ...]
 *   }
 */
export const accountIdsByGroupIdSelector = createSelector(
  accountsSelector,
  sortedAccountsSelector,
  groupIdsSelector,
  (accounts, sortedAccounts, groupIds) => {
    const accountsByGroupMap = groupIds.reduce((map, id) => {
      map[id] = [];
      return map;
    }, {});

    const hasSortedAccounts = sortedAccounts && sortedAccounts.length;
    const accountsToGroup = hasSortedAccounts ? sortedAccounts : accounts;
    accountsToGroup.forEach((a) => {
      if (a.groupId !== null) {
        accountsByGroupMap[a.groupId].push(a.id);
      }
    });

    return accountsByGroupMap;
  }
);
